<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :label-width="120">
                <FormItem :label="$t('org_cname')" prop="role_cname">
                    <Input v-model="org_cname" disabled></Input>
                </FormItem>
                <FormItem :label="$t('role_cname')" prop="role_cname">
                    <Input :value="`[${cat_cname || `${$t('self')}`}] ${role_cname}`" disabled></Input>
                </FormItem>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit('down-role-s2/del')">{{$t('del')}}</Button>
            <Button type="error" @click="submitAll" v-if="$base.getOrgId() != org_id">{{$t('deleterole')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                formData: {
                    role_id:'',
                },
                role_cname: '',
                org_cname: '',
                cat_cname: '',
                listData: [],
                org_id: ''
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.role_id = this.$base.getRequest().role_id;
            this.org_id = this.$base.getRequest().org_id;
            this.role_cname = this.$base.getRequest().role_cname;
            this.org_cname = this.$base.getRequest().org_cname;
            this.cat_cname = this.$base.getRequest().cat_cname;
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            submit: function(url){
                this.$base.showLoading();
                this.$request.sendPost(url,this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.msgSuccess(error.errmsg);
                        this.relist = true;
                        this.$base.linkBack();
                    }
                    else{
                        this.$base.msgErr(error.errmsg);
                    }
                });
            },
            submitAll: function () {
                let content = this.$t('confirm_deleterole');
                let title =  this.$t('tips');
                this.$base.confirm(title,content, () => {
                    this.submit('down-role-s2/del-all')
                },()=>{})
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/downrole/downroles2_delete.vue